module.exports = __webpack_public_path__ + "img/AVPN-Blog-967x683.6f5b9c4b.png";